import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_OEM = createActionTypes('FETCH_OEM');
export const GET_OEM = createActionTypes('GET_OEM');
export const CREATE_OEM = createActionTypes('CREATE_OEM');
export const UPDATE_OEM = createActionTypes('UPDATE_OEM');
export const DELETE_OEM = createActionTypes('DELETE_OEM');
export const OEM_UPDATE_FIRMWARE = createActionTypes('OEM_UPDATE_FIRMWARE');
